import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { Loader2 } from "lucide-react";
import { getDefaultRouteForUser } from "../../../utils/roleAccess";

type AdminRouteGuardProps = {
  children: React.ReactNode;
};

/**
 * Accès shell /admin : session staff requise, rôle CLIENT interdit.
 * Ne gère pas le RBAC par module (voir AdminPermissionOutlet).
 */
export default function AdminRouteGuard({ children }: AdminRouteGuardProps): React.JSX.Element {
  const { user, isLoading, accessToken } = useAuth();
  const hasStaffToken = Boolean(accessToken ?? localStorage.getItem("accessToken"));
  const roleStored = localStorage.getItem("role");
  const role = user?.role ?? roleStored;
  const r = String(role ?? "").toLowerCase();
  const isClient = r === "client";
  const isTerrainAgent =
    r === "agent" || r === "agent_terrain" || r === "chauffeur";

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center gap-2 bg-slate-950 text-slate-400">
        <Loader2 className="h-5 w-5 animate-spin" />
        Chargement…
      </div>
    );
  }

  if (!hasStaffToken && !user) {
    return <Navigate to="/login" replace />;
  }

  if (isClient || isTerrainAgent) {
    return <Navigate to={getDefaultRouteForUser({ role })} replace />;
  }

  return <>{children}</>;
}
